// extracted by mini-css-extract-plugin
module.exports = {"pre-book-info":"PhvyKM","pre-book-title-tag":"_1PoXCi","price-breakup-row":"BCbmlQ","price":"_2z3MDg","text":"X1pQvf","pay-now-price":"cEDoOZ","sfl-pre-book-tag":"_2L-LIv"};